import {ChevronDownIcon, ChevronUpIcon} from '@primer/octicons-react'
import {Box, IconButton} from '@primer/react'

import {BUTTON_LABELS} from '../../constants'

type HeaderNavigationProps = {
  navigatePrevious?: () => void
  navigateNext?: () => void
  collapsed?: boolean
}

export const HeaderNavigation = ({navigatePrevious, navigateNext, collapsed}: HeaderNavigationProps) => {
  if (navigatePrevious === undefined && navigateNext === undefined) {
    return null
  }

  return (
    <Box
      sx={{
        gap: 0,
        display: ['flex', 'flex', collapsed ? 'none' : 'flex', 'none'],
      }}
    >
      <IconButton
        className="tooltipped tooltipped-s"
        variant="invisible"
        size="medium"
        aria-label={BUTTON_LABELS.previousItem}
        icon={ChevronUpIcon}
        disabled={navigatePrevious === undefined}
        onClick={navigatePrevious}
      />
      <IconButton
        className="tooltipped tooltipped-s"
        variant="invisible"
        size="medium"
        aria-label={BUTTON_LABELS.nextItem}
        icon={ChevronDownIcon}
        disabled={navigateNext === undefined}
        onClick={navigateNext}
      />
    </Box>
  )
}

try{ HeaderNavigation.displayName ||= 'HeaderNavigation' } catch {}